import {
  ListItemButton,
  type ListItemButtonProps,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { ExitToApp as ExitIcon } from '@mui/icons-material';
import { FormattedMessage } from 'react-intl';
import useLogout from './useLogout';

const LogoutButton = (props: Omit<ListItemButtonProps, 'children'>) => {
  const logout = useLogout();

  return (
    <ListItemButton onClick={logout} {...props}>
      <ListItemIcon>
        <ExitIcon />
      </ListItemIcon>
      <ListItemText
        primary={<FormattedMessage id="header.options_menu.options.logout" />}
      />
    </ListItemButton>
  );
};

export default LogoutButton;
